import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import { CashierFlowType } from '@swf/first';
import trScreenVideo from '@swf/first/assets/video/tr-screen-video.mp4';
import trVideoMobile from '@swf/first/assets/video/tr-video-mobile.mp4';

import Prompt from '../Prompt/Prompt';

import {
  TXTCLI_Continue_to_Cashier,
  TXTWCL_Continue_to_deposit,
  TXTWCL_Continue_to_withdraw,
  TXTWCL_Take_the_tour,
  TXTWCL_WeXve_made_some_improvements_f_ELL,
  TXTWCL_Welcome_to_the_new_Cashier_,
  TXTWCL_Welcome_to_the_new_deposit_exp_ELL,
  TXTWCL_Welcome_to_the_new_withdrawal__ELL
} from './PromptTour.messages.json';
import { usePromptTourActions } from './usePromptTourActions';

interface Props {
  flow?: 'cashier' | CashierFlowType;
}

const PromptTour: React.FC<Props> = ({ flow = '' }) => {
  const isMobile = useSelector(select.device.isMobile);
  const video = isMobile ? trVideoMobile : trScreenVideo;
  const { userSeenPrompt } = useSelector(select.localSettings.get);
  const updateUserTour = usePromptTourActions();
  const isSwcTurorial = useFeature(FeatureFlag.SwcTurorial);
  const showCashierTour = useSelector(select.account.showCashierTour);

  if (
    !(
      [CashierFlowType.FirstDeposit, CashierFlowType.FirstWithdraw, 'cashier'].includes(flow) &&
      showCashierTour
    ) ||
    userSeenPrompt?.[flow]
  )
    return null;

  const translations = {
    [CashierFlowType.FirstDeposit]: {
      title: TXTWCL_Welcome_to_the_new_deposit_exp_ELL,
      btn: TXTWCL_Continue_to_deposit
    },
    [CashierFlowType.FirstWithdraw]: {
      title: TXTWCL_Welcome_to_the_new_withdrawal__ELL,
      btn: TXTWCL_Continue_to_withdraw
    },
    cashier: {
      title: TXTWCL_Welcome_to_the_new_Cashier_,
      btn: TXTCLI_Continue_to_Cashier
    }
  };

  return (
    <Prompt
      title={{
        translation: translations[flow]?.title
      }}
      variant="info"
      onClose={() => updateUserTour(flow)}
      primaryButton={{ translation: translations[flow]?.btn }}
      onPrimaryButtonClick={() => updateUserTour(flow)}
      secondaryButton={
        flow === 'cashier' && isSwcTurorial ? { translation: TXTWCL_Take_the_tour } : undefined
      }
      onSecondaryButtonClick={() => updateUserTour(flow)}
      video={video}
      isVideoTour
    >
      <Translation {...TXTWCL_WeXve_made_some_improvements_f_ELL} />
    </Prompt>
  );
};

export default PromptTour;
